import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function PaymentConfirm() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const tournamentId = searchParams.get('t');

  const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'error'
  const [error, setError]   = useState('');

  useEffect(() => {
    if (!token || !tournamentId) { setStatus('error'); setError('Lien invalide.'); return; }
    axios.post(`${API_URL}/api/payments/confirm`, { token, tournamentId })
      .then(() => setStatus('ok'))
      .catch(err => { setStatus('error'); setError(err.response?.data?.error || 'Lien invalide ou expiré'); });
  }, [token, tournamentId]);

  return (
    <div className="screen" style={{ background: 'var(--ink)', minHeight: '100vh' }}>
      <div style={{ height: 54 }} />
      <div style={{ padding: '8px 24px 40px', overflowY: 'auto' }}>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 32, marginBottom: 28 }}>
          <div className="display" style={{ fontSize: 36, lineHeight: 0.9, textAlign: 'center' }}>Confirmation de paiement</div>
        </div>

        {status === 'error' && (
          <div style={{
            padding: '10px 14px', borderRadius: 10, marginBottom: 16,
            background: 'rgba(229,80,62,0.1)', color: '#E5503E',
            fontSize: 13, fontWeight: 600, border: '1px solid rgba(229,80,62,0.25)',
          }}>{error}</div>
        )}

        {status === 'loading' ? (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>Confirmation en cours…</span>
          </div>
        ) : status === 'ok' ? (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
              Ton paiement est confirmé !
            </span>
          </div>
        ) : (
          <div className="card col gap-2" style={{ padding: 18, textAlign: 'center' }}>
            <span style={{ color: 'var(--text)', fontSize: 14, lineHeight: 1.5 }}>
              Refais une demande depuis la page du tournoi.
            </span>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 28, gap: 6 }}>
          <Link to={tournamentId ? `/tournaments/${tournamentId}` : '/dashboard'}
            style={{ color: 'var(--sun)', fontSize: 13, fontWeight: 700, textDecoration: 'none' }}>
            Retour au tournoi
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PaymentConfirm;
